import React, { Component } from "react";
import { MqttContext } from "../../Contexts/MqttProvider";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Grid,
  Skeleton,
  Divider,
} from "@mui/material";

const accountMapping = {
  117117224: "EURUSD",
  257493763: "EURUSDcn",
  415268292: "DiabloKong",
  117108730: "EURUSD 2.0",
  263217294: "EURUSD 3.0",
  141055910: "XAUUSD",
  52231581: "LOW RISK XAU",
  117052440: "JKW XAU",
  // 111130765: "JKW 24HR XAU",
  // 52236446: "SPDR XAU",
  111162399: "SM",
  159018075: "JKW 3.0 XAU",
  159720510: "WOW",
  160007581: "Diablo",
  // 183708271: "JKW24K",
  // 183057268: "JKWRJWFast",
  270886869: "RJW88Slow",
  270638630: "RJW88Fast",
  206985092: "JKW88",
  // 159840552: "CTC",
  49464860: "FTG",
  183159956: "OSOK",
  159649327: "BTC",
  159840552: "BTCMu",
  257265524: "BlueStar",
  159887898: "BlueStar5",
  183714991: "BlueStar15",
  183947812: "DiabloBoi",
  159829134: "DiabloMan",
  159852022: "BlueStar15R",
  117116267: "GBPJPY",
};

class AccountMetricTabs extends Component {
  static contextType = MqttContext;

  constructor(props) {
    super(props);
    this.state = {
      activeTab: "EURUSD",
    };
    this.isSubscribed = false;
  }

  componentDidMount() {
    this.trySubscribeToMetrics();
  }

  componentDidUpdate() {
    this.trySubscribeToMetrics();
  }

  componentWillUnmount() {
    const { unsubscribeFromTopic, client, isConnected } = this.context;
    if (client && isConnected) {
      Object.keys(accountMapping).forEach((acc) => {
        unsubscribeFromTopic(`Account/${acc}/metricOntick`);
        unsubscribeFromTopic(`Account/${acc}/profit/utcp0`);
      });
      // Object.entries({
      //   117117224: "EURUSD",
      //   117108730: "EURUSDc",
      //   117052440: "XAUUSDc",
      //   111130765: "XAUUSDc",
      //   141055910: "XAUUSDc",
      //   52231581: "XAUUSDc",
      //   52236446: "XAUUSDc",
      //   111162399: "EURUSDc",
      //   159018075: "XAUUSDc",
      //   49464860: "XAUUSDm",
      //   159649327: "BTCUSDc",
      // }).forEach(([acc, symbol]) => {
      //   unsubscribeFromTopic(`TradedataV2/${acc}/${symbol}`);
      // });
    }
  }

  trySubscribeToMetrics = () => {
    const { subscribeToTopic, isConnected, client } = this.context;
    if (isConnected && client && !this.isSubscribed) {
      Object.keys(accountMapping).forEach((acc) => {
        subscribeToTopic(`Account/${acc}/metricOntick`);
        subscribeToTopic(`Account/${acc}/profit/utcp0`);
      });
      // Object.entries({
      //   117117224: "EURUSD",
      //   117108730: "EURUSDc",
      //   117052440: "XAUUSDc",
      //   111130765: "XAUUSDc",
      //   141055910: "XAUUSDc",
      //   52231581: "XAUUSDc",
      //   52236446: "XAUUSDc",
      //   111162399: "EURUSDc",
      //   159018075: "XAUUSDc",
      //   49464860: "XAUUSDm",
      //   159649327: "BTCUSDc",
      // }).forEach(([acc, symbol]) => {
      //   subscribeToTopic(`TradedataV2/${acc}/${symbol}`);
      // });

      this.isSubscribed = true;
    }
  };

  getMetricDataForSymbol = (symbol) => {
    const { messagesAccountMetric } = this.context;
    const accountNumber = Object.keys(accountMapping).find(
      (acc) => accountMapping[acc] === symbol,
    );
    return (
      (messagesAccountMetric && messagesAccountMetric[accountNumber]) || null
    );
  };

  getProfitToday = (symbol) => {
    const { messagesAccountProfitToday } = this.context;
    const accountNumber = Object.keys(accountMapping).find(function (acc) {
      return accountMapping[acc] === symbol;
    });

    if (
      messagesAccountProfitToday &&
      messagesAccountProfitToday[accountNumber] &&
      typeof messagesAccountProfitToday[accountNumber].profit !== "undefined"
    ) {
      const rawProfit = messagesAccountProfitToday[accountNumber].profit;
      const isCentAccount = [
        "117117224",
        "257493763",
        "415268292",
        "117108730",
        "263217294",
        "141055910",
        "117052440",
        "111130765",
        "52231581",
        "52236446",
        "111162399",
        "159018075",
        "159720510",
        "160007581",
        "159649327",
        // "183708271",
        "183714991",
        // "183057268",
        "257265524",
        "159840552",
        // "159840552",
        "159829134",
        "117116267",
        "159852022",
        "270886869",
        "270638630",
        "206985092",
        "159887898",
        "183947812",
        "183159956",
      ].includes(accountNumber);
      return isCentAccount ? rawProfit / 100 : rawProfit;
    }

    return null;
  };

  getTradeData = (symbol) => {
    const { messagesTradeDataV2 } = this.context;

    const accountNumber = Object.keys(accountMapping).find(
      (acc) => accountMapping[acc] === symbol,
    );

    const tradeDataMapping = {
      117117224: "EURUSD",
      257493763: "EURUSDc",
      415268292: "EURUSDc",
      117108730: "EURUSDc",
      263217294: "EURUSDc",
      117052440: "XAUUSDc",
      111130765: "XAUUSDc",
      141055910: "XAUUSDc",
      52231581: "XAUUSDc",
      52236446: "XAUUSDc",
      111162399: "EURUSDc",
      159018075: "XAUUSDc",
      159720510: "XAUUSDc",
      160007581: "XAUUSDc",
      // 183708271: "XAUUSDc",
      183714991: "XAUUSDc",
      // 183057268: "XAUUSDc",
      // 159840552: "XAUUSDc",
      159852022: "XAUUSDc",
      270886869: "XAUUSDm",
      270638630: "XAUUSDm",
      206985092: "XAUUSDm",
      159887898: "XAUUSDc",
      49464860: "XAUUSDm",
      183159956: "XAUUSDc",
      159649327: "BTCUSDc",
      257265524: "XAUUSDc",
      159840552: "BTCUSDc",
      159829134: "BTCUSDc",
      183947812: "BTCUSDc",
      117116267: "GBPJPY",
    };

    const mappedSymbol = tradeDataMapping[accountNumber];
    const key = `${accountNumber}_${mappedSymbol}`;

    if (messagesTradeDataV2 && messagesTradeDataV2[key]) {
      return {
        data: messagesTradeDataV2[key],
        symbol: mappedSymbol,
      };
    }
    return {
      data: null,
      symbol: null,
    };
  };

  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  renderMetric(data, profitToday) {
    if (!data) {
      return (
        <Box mt={2} px={2}>
          <Skeleton height={30} />
          <Skeleton height={30} width="80%" />
          <Skeleton height={30} width="90%" />
        </Box>
      );
    }

    const accountNumber = String(data.accountNumber);
    const isCentAccount = [
      "117117224",
      "117108730",
      "263217294",
      "141055910",
      "117052440",
      "111130765",
      "52231581",
      "52236446",
      "111162399",
      "159018075",
      "159720510",
      "160007581",
      "159649327",
      // "183708271",
      "183714991",
      // "183057268",
      // "159840552",
      "257265524",
      "159840552",
      "159829134",
      "183947812",
      "117116267",
      "159852022",
      "270886869",
      "270638630",
      "206985092",
      "159887898",
      "183159956",
      "257493763",
      "415268292",
    ].includes(accountNumber);

    const converted = { ...data };
    if (isCentAccount) {
      converted.balance = data.balance / 100;
      converted.equity = data.equity / 100;
      converted.floating = data.floating / 100;
    }

    const standardByAccount = {
      117117224: 2000,
      257493763: 2000,
      415268292: 2000,
      117108730: 2000,
      263217294: 1000,
      141055910: 10000,
      117052440: 2000,
      111130765: 500,
      52231581: 2500,
      52236446: 500,
      111162399: 500,
      159018075: 1000,
      159649327: 1000,
      49464860: 10000,
      159720510: 100,
      160007581: 1000,
      // 183708271: 1000,
      183714991: 1000,
      // 183057268: 2000,
      159852022: 1000,
      270886869: 3000,
      270638630: 3000,
      206985092: 3000,
      257265524: 1000,
      159840552: 1000,
      // 159840552: 1000,
      159829134: 1000,
      183947812: 1000,
      183159956: 5000,
      117116267: 500,
      159887898: 1000,
    };

    const floatPercent = standardByAccount[accountNumber]
      ? ((converted.floating / standardByAccount[accountNumber]) * 100).toFixed(
          2,
        )
      : "0.00";

    const groupOrders = (data.order && data.order.tpGroups) || [];
    const groupOrdersBuy = groupOrders.find((o) => o.type === 0) || {};
    const groupOrdersSell = groupOrders.find((o) => o.type === 1) || {};

    const estProfitBuy = isCentAccount
      ? (groupOrdersBuy.estimatedProfit || 0) / 100
      : groupOrdersBuy.estimatedProfit || 0;

    const estProfitSell = isCentAccount
      ? (groupOrdersSell.estimatedProfit || 0) / 100
      : groupOrdersSell.estimatedProfit || 0;

    const totalLots =
      (groupOrdersBuy.totalLots || 0) + (groupOrdersSell.totalLots || 0);

    const getColor = (
      value,
      positive = "lightgreen",
      negative = "red",
      neutral = "#ccc",
    ) => {
      if (value > 0) return positive;
      if (value < 0) return negative;
      return neutral;
    };

    const { symbol: tradeSymbol } = this.getTradeData(
      accountMapping[accountNumber],
    );

    // console.log("symbol:", tradeSymbol, "data:", data);

    var priceList = data && data.price ? data.price : {};
    var symbolKey = tradeSymbol;

    if (!symbolKey && Object.keys(priceList).length > 0) {
      symbolKey = Object.keys(priceList)[0];
    }

    var priceInfo = priceList[symbolKey];
    var bid = priceInfo && priceInfo.bid != null ? priceInfo.bid : null;
    var ask = priceInfo && priceInfo.ask != null ? priceInfo.ask : null;

    var priceBuy = bid;
    var priceSell = ask;

    var spreadPoint = null;

    if (bid != null && ask != null && priceInfo) {
      var point = Number(priceInfo.point ? priceInfo.point : 1);

      spreadPoint = Math.round((ask - bid) / point);

      // fallback manual multiplier kalau point tidak diset
      // if (!priceInfo.point) {
      //   if (/^EURUSD(c|m)?$/i.test(symbolKey)) {
      //     spreadPoint = Math.round((ask - bid) * 100000);
      //   } else if (/^XAUUSD(c|m)?$/i.test(symbolKey)) {
      //     spreadPoint = Math.round((ask - bid) * 100);
      //   } else if (/^BTCUSD(c|m)?$/i.test(symbolKey)) {
      //     spreadPoint = Math.round((ask - bid) * 100);
      //   } else {
      //     spreadPoint = Math.round(ask - bid);
      //   }
      // }

      // console.log("symbolKey:", symbolKey, "point:", point);

      if (["EURUSD", "EURUSDc"].includes(symbolKey)) {
        spreadPoint = Math.round((ask - bid) * 100000);
        // console.log(`Using manual multiplier for ${tradeSymbol}`);
      } else if (["XAUUSD", "XAUUSDc", "XAUUSDm"].includes(symbolKey)) {
        spreadPoint = Math.round((ask - bid) * 100);
        // console.log(`Using manual multiplier for ${tradeSymbol}`);
      } else if (["BTCUSD", "BTCUSDc", "BTCUSDm"].includes(symbolKey)) {
        spreadPoint = Math.round(ask - bid);
        // console.log(`Using manual multiplier for ${tradeSymbol}`);
      } else if (["GBPJPY", "GBPJPYc", "GBPJPYm"].includes(symbolKey)) {
        spreadPoint = Math.round((ask - bid) * 100);
      } else {
        spreadPoint = Math.round(ask - bid);
      }
    }

    // console.log({
    //   symbol: symbolKey,
    //   bid: bid,
    //   ask: ask,
    //   spreadPoint: spreadPoint,
    // });

    return (
      <Box
        mt={2}
        sx={{
          bgcolor: "#1e2f4d",
          borderRadius: 2,
          px: { xs: 1.5, sm: 2, md: 3 },
          py: { xs: 1.5, sm: 2 },
          color: "#fff",
          fontSize: {
            xs: "0.7rem",
            sm: "0.85rem",
            md: "0.95rem",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1,
            mb: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.8rem", sm: "1.0rem", md: "1.2rem" },
            }}
          >
            Floating:{" "}
            <strong style={{ color: getColor(converted.floating) }}>
              {converted.floating >= 0 ? "+" : "-"}$
              {Math.abs(converted.floating).toFixed(2)}
            </strong>
            ({" "}
            <strong style={{ color: getColor(floatPercent) }}>
              {floatPercent}%
            </strong>{" "}
            ) | Total Lot:{" "}
            <strong style={{ color: getColor(totalLots, "orange", "red") }}>
              {totalLots.toFixed(2)}
            </strong>
          </Typography>
        </Box>
        {profitToday != null && !isNaN(parseFloat(profitToday)) && (
          <Typography
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
              mb: 1,
            }}
          >
            Profit Today:{" "}
            <strong style={{ color: getColor(parseFloat(profitToday)) }}>
              ${parseFloat(profitToday).toFixed(2)}
            </strong>
          </Typography>
        )}

        <Divider sx={{ bgcolor: "#ffffff33", mb: 2 }} />

        {priceBuy && priceSell && (
          <Typography
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
              mb: 1,
            }}
          >
            BID/ASK:{" "}
            <strong>
              {(priceBuy && priceBuy) || "-"} /{" "}
              {(priceSell && priceSell) || "-"} | Spread:{" "}
              {spreadPoint != null ? spreadPoint : "-"} pts
            </strong>
          </Typography>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography
              fontWeight="bold"
              color="lightgreen"
              gutterBottom
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
              }}
            >
              Buy ({groupOrdersBuy.totalOrder || 0})
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                columnGap: 2,
                rowGap: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                TP:{" "}
                <strong style={{ color: "deepskyblue" }}>
                  {groupOrdersBuy.takeProfit || "-"}
                </strong>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                Point:{" "}
                <strong
                  style={{
                    color: getColor(groupOrdersBuy.pointDiff, "orange", "red"),
                  }}
                >
                  {groupOrdersBuy.pointDiff || 0}
                </strong>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                Est:{" "}
                <strong style={{ color: getColor(estProfitBuy) }}>
                  ${parseFloat(estProfitBuy).toFixed(2)}
                </strong>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                Lot:{" "}
                <strong
                  style={{
                    color: getColor(groupOrdersBuy.totalLots, "orange", "red"),
                  }}
                >
                  {(groupOrdersBuy.totalLots || 0).toFixed(2)}
                </strong>
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              fontWeight="bold"
              color="red"
              gutterBottom
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
              }}
            >
              Sell ({groupOrdersSell.totalOrder || 0})
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                columnGap: 2,
                rowGap: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                TP:{" "}
                <strong style={{ color: "deepskyblue" }}>
                  {groupOrdersSell.takeProfit || "-"}
                </strong>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                Point:{" "}
                <strong
                  style={{
                    color: getColor(groupOrdersSell.pointDiff, "orange", "red"),
                  }}
                >
                  {groupOrdersSell.pointDiff || 0}
                </strong>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                Est:{" "}
                <strong style={{ color: getColor(estProfitSell) }}>
                  ${parseFloat(estProfitSell).toFixed(2)}
                </strong>
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                }}
              >
                Lot:{" "}
                <strong
                  style={{
                    color: getColor(groupOrdersSell.totalLots, "orange", "red"),
                  }}
                >
                  {(groupOrdersSell.totalLots || 0).toFixed(2)}
                </strong>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }

  render() {
    const { activeTab } = this.state;
    const profitToday = this.getProfitToday(activeTab);
    const metricData = this.getMetricDataForSymbol(activeTab);

    return (
      <Box>
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            mb: 1,
            borderRadius: 2,
            bgcolor: "#eaeaea",
            px: 1,
            "& .MuiTabs-flexContainer": { gap: 1 },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: 2,
              minHeight: 40,
              fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
            },
            "& .Mui-selected": {
              bgcolor: "#1e2f4d",
              color: "#fff !important",
            },
          }}
        >
          {[
            "EURUSD",
            "EURUSDcn",
            "EURUSD 2.0",
            "EURUSD 3.0",
            "DiabloKong",
            "SM",
            "XAUUSD",
            "LOW RISK XAU",
            "JKW XAU",
            // "JKW 24HR XAU",
            "JKW 3.0 XAU",
            // "JKW24K",
            "JKW88",
            //"JKWRJWFast",
            "RJW88Slow",
            "RJW88Fast",
            "WOW",
            "Diablo",
            "BlueStar",
            "BlueStar5",
            "BlueStar15",
            "DiabloBoi",
            "DiabloMan",
            "BlueStar15R",
            //"CTC",
            "FTG",
            "OSOK",
            "BTC",
            "BTCMu",
            "GBPJPY",
          ].map((symbol) => (
            <Tab
              key={symbol}
              label={symbol}
              value={symbol}
              sx={{ px: { xs: 1.5, sm: 2.5 }, color: "#333" }}
            />
          ))}
        </Tabs>

        <Box p={0} mb={2}>
          {this.renderMetric(metricData, profitToday)}
        </Box>
      </Box>
    );
  }
}

export default AccountMetricTabs;
